var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        keyboard: false,
        forceRender: true,
        prefixNo: _vm.prefixNo,
        fullscreen: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrintPro("组装单")
                    },
                  },
                },
                [_vm._v("三联打印-新版")]
              )
            : _vm._e(),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrint("组装单")
                    },
                  },
                },
                [_vm._v("三联打印")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanCheck
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.confirmLoading },
                  on: { click: _vm.handleOkAndCheck },
                },
                [_vm._v("保存并审核")]
              )
            : _vm._e(),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleOkOnly },
            },
            [_vm._v("保存（Ctrl+S）")]
          ),
          !_vm.checkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleWorkflow()
                    },
                  },
                },
                [_vm._v("提交流程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "operTime",
                                  _vm.validatorRules.operTime,
                                ],
                                expression:
                                  "['operTime', validatorRules.operTime]",
                              },
                            ],
                            attrs: { "show-time": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["number", _vm.validatorRules.number],
                                expression:
                                  "[ 'number', validatorRules.number ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入单据编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { lg: 6, md: 12, sm: 24 } }),
                  _c("a-col", { attrs: { lg: 6, md: 12, sm: 24 } }),
                ],
                1
              ),
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  id: "billModal",
                  loading: _vm.materialTable.loading,
                  columns: _vm.materialTable.columns,
                  dataSource: _vm.materialTable.dataSource,
                  minWidth: _vm.minWidth,
                  maxHeight: 300,
                  rowNumber: true,
                  rowSelection: true,
                  actionButton: true,
                },
                on: {
                  valueChange: _vm.onValueChange,
                  added: _vm.onAdded,
                  deleted: _vm.onDeleted,
                },
                scopedSlots: _vm._u([
                  {
                    key: "buttonAfter",
                    fn: function () {
                      return [
                        _c(
                          "a-row",
                          {
                            staticStyle: { float: "left" },
                            attrs: {
                              gutter: 24,
                              "data-step": "4",
                              "data-title": "扫码录入",
                              "data-intro":
                                "此功能支持扫码枪扫描商品条码进行录入",
                            },
                          },
                          [
                            _vm.scanStatus
                              ? _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-button",
                                      { on: { click: _vm.scanEnter } },
                                      [_vm._v("扫码录入")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.scanStatus
                              ? _c(
                                  "a-col",
                                  {
                                    staticStyle: { padding: "0 6px 0 12px" },
                                    attrs: { md: 16, sm: 24 },
                                  },
                                  [
                                    _c("a-input", {
                                      ref: "scanBarCode",
                                      attrs: {
                                        placeholder: "请扫描商品条码并回车",
                                      },
                                      on: { pressEnter: _vm.scanPressEnter },
                                      model: {
                                        value: _vm.scanBarCode,
                                        callback: function ($$v) {
                                          _vm.scanBarCode = $$v
                                        },
                                        expression: "scanBarCode",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.scanStatus
                              ? _c(
                                  "a-col",
                                  {
                                    staticStyle: { padding: "0px" },
                                    attrs: { md: 6, sm: 24 },
                                  },
                                  [
                                    _c(
                                      "a-button",
                                      { on: { click: _vm.stopScan } },
                                      [_vm._v("收起扫码")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "depotBatchSet",
                    fn: function () {
                      return [
                        _c("a-icon", {
                          attrs: { type: "down" },
                          on: { click: _vm.handleBatchSetDepot },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "depotAdd",
                    fn: function () {
                      return [
                        _vm.quickBtn.depot
                          ? _c("a-divider", {
                              staticStyle: { margin: "4px 0" },
                            })
                          : _vm._e(),
                        _vm.quickBtn.depot
                          ? _c(
                              "div",
                              {
                                staticClass: "dropdown-btn",
                                on: { click: _vm.addDepot },
                              },
                              [
                                _c("a-icon", { attrs: { type: "plus" } }),
                                _vm._v(" 新增"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-btn",
                            on: {
                              mousedown: (e) => e.preventDefault(),
                              click: _vm.initDepot,
                            },
                          },
                          [
                            _c("a-icon", { attrs: { type: "reload" } }),
                            _vm._v(" 刷新"),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 24, md: 24, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
                            label: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["remark"],
                                expression: "[ 'remark' ]",
                              },
                            ],
                            staticStyle: { "margin-top": "8px" },
                            attrs: { rows: 1, placeholder: "请输入备注" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "附件",
                          },
                        },
                        [
                          _c("j-upload", {
                            attrs: { bizPath: "bill" },
                            model: {
                              value: _vm.fileList,
                              callback: function ($$v) {
                                _vm.fileList = $$v
                              },
                              expression: "fileList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("depot-modal", {
        ref: "depotModalForm",
        on: { ok: _vm.depotModalFormOk },
      }),
      _c("batch-set-depot", {
        ref: "batchSetDepotModalForm",
        on: { ok: _vm.batchSetDepotModalFormOk },
      }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
      _c("bill-print-iframe", { ref: "modalPrint" }),
      _c("bill-print-pro-iframe", { ref: "modalPrintPro" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }